import { type ConfirmOptions, useConfirmDialogStore } from '@/store/useConfirmDialogStore'

/**
 * window.confirm の代わり。確定なら true、キャンセル・背景タップ・Esc は false
 *
 * window.confirm はブラウザの「このページのダイアログを表示しない」を選ぶと黙って false を返し、
 * 以後その操作が一切できなくなる。表示は App 直下の ConfirmDialogHost が受け持つ。
 */
export const confirmDialog = (options: ConfirmOptions): Promise<boolean> =>
  useConfirmDialogStore.getState().open(options)
